<app-loading />
<div class="loyalty-shell pos-relative w-100">
   <main class="pageWraper p-t-10" [class.with-tabbar]="showFooter">
      <router-outlet />
      @if (showFooter) {
      <div class="loyalty-tabbar-fixed">
         <div class="loyalty-shell">
            <app-footer />
         </div>
      </div>
      }
   </main>
</div>
